import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { Organization } from './organization'
import { organizationActions } from './organization.actions'
import * as fromOrganization from './organization.reducer'
import { OrganizationService } from './organization.service'
import { switchMap, map } from 'rxjs/operators'
import { normalizeToSchema } from 'src/app/shared/normalization/normalization'
import { normalizationActions } from 'src/app/shared/normalization/normalization.actions'

@Injectable()
export class OrganizationEffects extends ResourceEffects<Organization> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    private organizationService: OrganizationService
  ) {
    super(
      fromOrganization.FEATURE_NAME,
      organizationService,
      organizationActions,
      actions$
    )
  }

  fetchManyPublic = createEffect(() =>
    this.actions$.pipe(
      ofType(organizationActions.fetchManyPublic),
      switchMap((action) =>
        this.organizationService.getManyPublic(action.params).pipe(
          map((organizations) =>
            normalizationActions.upsertMany({
              entities: normalizeToSchema({ organizations })
            })
          )
        )
      )
    )
  )
}
